// src/api/config.js
const API_BASE_URL = "https://blockhunt-backend.onrender.com";

export default API_BASE_URL;